import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { useRoute } from "vue-router/composables";
import { computed } from "vue";
import { useRootStore } from "@/store/pinia";
import { useQuery } from "@vue/apollo-composable";
import { queries } from "@/apollo";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBreadcrumb',
  emits: ["search"],
  setup(__props, { emit }) {

const route = useRoute();

const userId = computed(() => {
  return route.query.userId;
});

const { result } = useQuery<{ user: User }>(
  queries.user,
  {
    userId: computed(() => userId.value),
  },
  {
    fetchPolicy: "cache-first",
  }
);



const me = computed(() => {
  return useRootStore().account;
});

const rootUser = computed(() => {
  return result.value?.user || me.value;
});

const breadCrumbConfig = computed(() => {
  const route = useRoute();

  const path = route.name;
  const meUserId = me.value?.userId;
  const lineageArr = rootUser.value?.lineageIds;
  if (!meUserId || !lineageArr) {
    return {
      home: {
        label: me.value?.userId.toUpperCase(),
        to: {
          name: path,
          query: { ...route.query, userId: me.value?.userId },
        },
      },
      items: [],
    };
  }
  const validItems = [...lineageArr];
  const meIndex = validItems.indexOf(meUserId);
  const items = validItems.slice(meIndex + 1).map((userId) => ({
    label: userId.toUpperCase(),
    to: { name: path, query: { ...route.query, userId } },
  }));
  return {
    home: {
      label: me.value?.userId.toUpperCase(),
      to: {
        name: path,
        query: { ...route.query, userId: me.value?.userId },
      },
    },
    items,
  };
});

return { __sfc: true,route, userId, result, emit, me, rootUser, breadCrumbConfig }
}

})